import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { FORGOT_PASSWORD_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { forgotPasswordFailure, forgotPasswordSuccess } from '../actions';

const ForgotPassweordAPI = (action) => postApiRequest(FORGOT_PASSWORD_API_URL, action);

function* handleForgotPassweordAPI(action) {
  try {
    const response = yield call(ForgotPassweordAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(forgotPasswordSuccess(response));
  } catch (error) {
    yield put(forgotPasswordFailure(error));
  }
}

export function* watchForgotPassword() {
  yield takeLatest(types.FORGOT_PASSWORD_REQUEST, handleForgotPassweordAPI);
}
